/**
 * Check if an error is retryable (network errors, timeouts, 5xx errors)
 */
export const isRetryableError = (error: unknown): boolean => {
  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    if (
      message.includes('network') ||
      message.includes('timeout') ||
      message.includes('fetch')
    ) {
      return true;
    }
  }

  if (error && typeof error === 'object' && 'networkError' in error) {
    return true;
  }

  return false;
};
